/**
 * Transform filter from activeFilters to resourceful format
 * @param {object} activeFilters
 * @returns {object} transformed filters
 * @example
 * filterMappings = {
 *   'status.name': (key, value) => `${key} eq '${value[0]}'`,
 * }
 *
 * activeFilters = {
 *  "status.name": { key: "status.name", value: ["DRAFT"] },
 * }
 *
 * queryParamFilters = [
 *   "status.name eq 'DRAFT'",
 * ]
 */
const transformFilter = (filterMappings, activeFilters) => {
  const filters = []

  for (let key of Object.keys(activeFilters)) {
    const filter = filterMappings[key]?.(key, activeFilters[key]) ?? undefined
    if (!filter) continue

    filters.push(filter)
  }

  return filters
}

export default transformFilter
